import React, { useEffect, useState } from "react";
import AlertComponent from "../alert/alert";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import BiddingPariticiptionDashboardTab from "./biddingPariticiptionDashboardTab";
import TransactionalP2PDashboardTab from "./transactionalP2PDashboardTab";
import RefreshIcon from "@mui/icons-material/Refresh";
import InvoicingDashboardTab from "./invoicingDashboardTab";
import { getSecPermission, inrDateFormatWithTime } from "../../constant";
import _ from "lodash";
import VendorOnboardingDasboardTab from "./vendorOnboardingDasboardTab";

const data = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 300 },
  { name: "Group C", value: 300 },
  { name: "Group D", value: 200 },
  { name: "Group E", value: 278 },
  { name: "Group F", value: 189 },
];

const data2 = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#00C49F",
  "#FFBB28",
];
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const permissionInit = {
  "create": false,
  "read": false,
  "update": false,
  "delete": false
};

function AdminDashboard() {
  const [adminheadingdashboard, setAdminHeadingDashboard] = React.useState(
    "Bidding Participation"
  );
  const [value, setValue] = React.useState(0);
  const [apiDate, setApiDate] = React.useState(new Date());
  const [count, setCount] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const anchorRef = React.useRef(null);
  const [alertComponent, setAlertComponent] = React.useState({
    open: false,
    message: "",
    type: "",
  });


  const [secDashboardPermission, setSecDashboardPermission] = useState({
    "DASHBOARD": permissionInit,
  });

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const comingPopup = () => {
    openAlert(true, "success", "coming soon....");
  };
  
  const addNewTime = (param) => {
    setApiDate(param);
  };

  useEffect(() => {
    // comingPopup();

    let secDashboardPermissionInit = _.cloneDeep(secDashboardPermission);
    let obj = {};
    for (let key in secDashboardPermissionInit) {
      obj[key] = getSecPermission(key);
    }

    setSecDashboardPermission(obj);

  }, []);

  const handleClose = (event) => {
    if (event) {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
    } else {
      setAlertComponent({ ...alertComponent, open: false });
    }
  };
  
  const refreshData = () => {
    setCount((prevData) => prevData + 1);
  };

  return (
    <div class="login-forms">
      {secDashboardPermission["DASHBOARD"]?.update == true && <div class="text-center">
        <div className="admin_dashboard_row1">
          <h2 className="dashboard_heading_transctional_row3">
            {value === 0
              ? "Vendor Onboarding Dashboard"
              : value === 1
                ? " Bidding Participation Dashboard"
                : value === 2
                  ? "P2P Transactional Dashboard"
                    : null}{" "}
          </h2>
          <div className="admin_dashboard_row_right">
            <RefreshIcon className="refresh_icon_dashboard" onClick={refreshData} />
            <CalendarMonthIcon fontSize="10px" />
            {/* <p>Last Update : 12 Mar , 20224 | 12:32 PM</p> */}
            <p>{inrDateFormatWithTime(Number(apiDate)) }</p>
          </div>
        </div>
        <div className="admin_dashboard_row2">
          <Box >
            <Box className="admin_dashboard_row2_tab ">
              <Tabs

                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                  <Tab label="Vendor Onboarding" {...a11yProps(0)} />
                <Tab label="Bidding Participation" {...a11yProps(1)} />
                <Tab label="P2P Transactional" {...a11yProps(2)} />
                {/* <Tab label="Invoicing" {...a11yProps(3)} /> */}
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <div className="admin_dashboard_row_div_bidding_invoicing_row">
               <VendorOnboardingDasboardTab addNewTime={addNewTime} count={count} />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <div className="admin_dashboard_row_div_bidding_invoicing_row">
                <BiddingPariticiptionDashboardTab addNewTime={addNewTime} count={count} />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <div className="admin_dashboard_row_div_bidding_invoicing_row">
                <TransactionalP2PDashboardTab addNewTime={addNewTime} count={count} />
              </div>
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={3}>
              <div className="admin_dashboard_row_div_bidding_invoicing_row">
                <InvoicingDashboardTab />
              </div>
            </CustomTabPanel> */}
          </Box>
        </div>
      </div>}

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
    </div>
  );
}

export default AdminDashboard;
